// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteActivityAnswer
 */
export interface LongWriteActivityAnswer {
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  activityAnswerId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  activityResultId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  blockId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  questionType?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  answerText?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityAnswer
   */
  plainText?: string | null
  /**
   *
   * @type {number}
   * @memberof LongWriteActivityAnswer
   */
  words?: number
  /**
   *
   * @type {Date}
   * @memberof LongWriteActivityAnswer
   */
  lastUpdatedDate?: Date
}

/**
 * Check if a given object implements the LongWriteActivityAnswer interface.
 */
export function instanceOfLongWriteActivityAnswer(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteActivityAnswerFromJSON(
  json: any,
): LongWriteActivityAnswer {
  return LongWriteActivityAnswerFromJSONTyped(json, false)
}

export function LongWriteActivityAnswerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteActivityAnswer {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityAnswerId: !exists(json, 'activityAnswerId')
      ? undefined
      : json['activityAnswerId'],
    activityResultId: !exists(json, 'activityResultId')
      ? undefined
      : json['activityResultId'],
    blockId: !exists(json, 'blockId') ? undefined : json['blockId'],
    questionType: !exists(json, 'questionType')
      ? undefined
      : json['questionType'],
    answerText: !exists(json, 'answerText') ? undefined : json['answerText'],
    plainText: !exists(json, 'plainText') ? undefined : json['plainText'],
    words: !exists(json, 'words') ? undefined : json['words'],
    lastUpdatedDate: !exists(json, 'lastUpdatedDate')
      ? undefined
      : new Date(json['lastUpdatedDate']),
  }
}

export function LongWriteActivityAnswerToJSON(
  value?: LongWriteActivityAnswer | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activityAnswerId: value.activityAnswerId,
    activityResultId: value.activityResultId,
    blockId: value.blockId,
    questionType: value.questionType,
    answerText: value.answerText,
    plainText: value.plainText,
    words: value.words,
    lastUpdatedDate:
      value.lastUpdatedDate === undefined
        ? undefined
        : value.lastUpdatedDate.toISOString(),
  }
}
